import { createFileRoute } from '@tanstack/react-router'
import { LandingInterlinks } from '@/features/landing/components/LandingInterlinks'
import { buildLandingIndexHead } from '@/lib/seo/landingHead'
import { useTrackOnce } from '@/hooks/useTrackOnce'
import { trackLandingViewed } from '@/lib/track'

export const Route = createFileRoute('/_layout/pobyty/')({
  component: LandingIndexPage,
  head: () => buildLandingIndexHead(),
})

function LandingIndexPage() {
  useTrackOnce(() => trackLandingViewed({ path: '/pobyty', kind: 'hub' }), [])

  return (
    <div className="container py-6 lg:py-10">
      <h1 className="mb-3 text-3xl font-semibold text-slate-900 lg:text-4xl">Tipy na ubytování</h1>
      <p className="mb-4 max-w-3xl text-lg text-slate-600">
        Nevíte, kam vyrazit? Vyberte si last-minute ubytování podle oblíbeného regionu, typu nebo vybavení – od chalup a
        chat přes pobyty se saunou a bazénem až po ubytování, kam smíte se psem.
      </p>
      <LandingInterlinks />
    </div>
  )
}
